export async function getClientId(): Promise<string> {
	const key = "clientId";
	const existing = localStorage.getItem(key);
	if (existing) return existing;

	const newId = crypto.randomUUID();
	localStorage.setItem(key, newId);
	return newId;
}
